import {SiteHeader} from '@modules'
import {React} from '@api'
import {RouteComponentProps, withRouter, WithRouterProps, WithRouterStatics} from 'react-router'
import * as css from './AdminPage.css'

export const AdminPage: React.ComponentClass<Omit<RouteComponentProps<any>, keyof RouteComponentProps<any>> & WithRouterProps<() => JSX.Element>> & WithRouterStatics<() => JSX.Element> = withRouter(() => {
  //site.currentLibrary

  return <div className={css.root}>
    <SiteHeader className={css.siteHeader}/>

    {/*<Link to={'/admin/elastic-search'}>ElasticSearch</Link>*/}
  </div>
})


// WEBPACK FOOTER //
// ./src/modules/admin/pages/AdminPage.tsx